import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { StyledTabs } from "../../styles/shared-components";
import { colors, spacing } from "../../styles/theme";
import { ServicesTab } from "../organisms/menu-services-tab/ServicesTab";
import { ResourcesTab } from "../organisms/menu-resources-tab/ResourcesTab";

const ServicesWrapper = styled.div`
  padding: ${spacing.xxl} 40px;
  background: ${colors.white};
  min-height: calc(100vh - 64px);

  @media (max-width: 768px) {
    padding: ${spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 ${spacing.xl} 0;
`;

const TabContentFullWidth = styled.div`
  width: 100%;
`;

export const ServicesNew: React.FC = () => {
    const { t } = useTranslation();
    const items = [
        {
            key: "services",
            label: t("servicesPage.servicesTab"),
            children: (
                <TabContentFullWidth>
                    <ServicesTab />
                </TabContentFullWidth>
            ),
        },
        {
            key: "resources",
            label: t("servicesPage.resourcesTab"),
            children: (
                <TabContentFullWidth>
                    <ResourcesTab />
                </TabContentFullWidth>
            ),
        },
    ];

    return (
        <ServicesWrapper>
            <PageTitle>{t("servicesPage.pageTitle")}</PageTitle>
            <StyledTabs defaultActiveKey="services" items={items} size="large" />
        </ServicesWrapper>
    );
};

export default ServicesNew;
